'use client';

import type { MouseEvent as ReactMouseEvent } from 'react';

import { Link, type Props as LinkProps } from '@/components/Link/Link';
import { HeaderNavigation } from '@/lib/tracking';
import { segment } from '@/lib/tracking/segmentAnalytics';

import { FOCUSABLE_ITEM_ATTRIBUTE } from './constants';

const KeyboardFocusableLink = ({ children, ...props }: LinkProps) => {
    function handleLinkClick(event: ReactMouseEvent<Element, MouseEvent>) {
        segment.track(HeaderNavigation.CLICKED_NAVIGATION_LINK, { path: props.href });

        if (props.onClick) {
            props.onClick(event);
        }
    }

    const linkProps = {
        ...props,
        [FOCUSABLE_ITEM_ATTRIBUTE]: true,
    };

    return (
        <Link {...linkProps} tabIndex={-1} onClick={handleLinkClick}>
            {children}
        </Link>
    );
};

export default KeyboardFocusableLink;
